// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchHistory_list__3qLlQ","temp":"SearchHistory_temp__yPkl9"};